import { type ComponentProps } from 'react';

import {
	RadioGroup as ArkRadioGroup,
	type RadioGroupRootProps as ArkRadioGroupRootProps
} from '@ark-ui/react';

import type { ActionColor, Scale3 } from '../../lib/types';
import { cn } from '../../lib/utils';

type RadioCardsProps = Omit<ArkRadioGroupRootProps, 'color'> & {
	size?: Scale3;
	variant?: 'surface' | 'classic';
	color?: ActionColor;
	highContrast?: boolean;
};

function RadioCardsRoot({
	className,
	size = '2',
	variant = 'surface',
	color = 'accent',
	highContrast,
	...props
}: RadioCardsProps) {
	return (
		<ArkRadioGroup.Root
			className={cn('pt-radio-cards', className)}
			data-size={size}
			data-variant={variant}
			data-accent-color={color}
			data-high-contrast={highContrast ? '' : undefined}
			{...props}
		/>
	);
}

function RadioCardsItem({ className, ...props }: ComponentProps<typeof ArkRadioGroup.Item>) {
	return <ArkRadioGroup.Item className={cn('pt-radio-cards-item', className)} {...props} />;
}

const RadioCards = Object.assign(RadioCardsRoot, {
	Root: RadioCardsRoot,
	Item: RadioCardsItem
});

export { RadioCards, type RadioCardsProps };
